module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/text_spot-ca92c792bbd2411e1bd0608e7891846b.svg";